import { deepCloneLayer } from '@/editor/history/cloneUtils'
import type { EditorHistoryCommand } from '@/editor/history/types'
import { getMockupHistoryBridge } from '@/editor/history/mockupEditorBridge'
import type { AnimationLayer } from '@/types/animationLayer'

/**
 * 用两份完整图层快照表示一次变更（撤销 / 重做各还原一侧）。
 */
export class ReplaceLayerSnapshotCommand implements EditorHistoryCommand {
  readonly label: string

  private readonly layerId: string

  private readonly before: AnimationLayer

  private readonly after: AnimationLayer

  /**
   * @param layerId - 图层 id
   * @param before - 变更前深拷贝
   * @param after - 变更后深拷贝
   * @param label - 描述
   */
  constructor(layerId: string, before: AnimationLayer, after: AnimationLayer, label: string) {
    this.layerId = layerId
    this.before = before
    this.after = after
    this.label = label
  }

  /** @inheritdoc */
  revert(): void {
    const b = getMockupHistoryBridge()
    b.replaceLayer(this.layerId, deepCloneLayer(this.before))
  }

  /** @inheritdoc */
  redo(): void {
    const b = getMockupHistoryBridge()
    b.replaceLayer(this.layerId, deepCloneLayer(this.after))
  }
}
